@if (showDayTripBreakdown()) {
  <!-- Totals are the manage-ta-info bubbles above; this adds the per-traveller split. -->
  <div class="flex flex-col gap-4 pb-4">
    <manage-ta-day-trip-payment-table [rows]="dayTripPaymentRows()"></manage-ta-day-trip-payment-table>
  </div>
}
